import { Model } from '@vuex-orm/core'

export default class Dexport extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'dexports'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      status: this.attr(null),
      current_item: this.attr(null),
      total_items: this.attr(null),
      entity: this.attr(null),
      title: this.attr(null),
      mime_type: this.attr(null),
      url: this.attr(null),
      bytes: this.attr(null),
      author_user_id: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Dexport.js